import React, { Fragment } from 'react';
import styled from 'styled-components';
import { COLORS, FONTS } from '@ertelecom/ui-react/assets/js/constants';
import MobileStoreButton from '@ertelecom/ui-react/components/buttons/mobileStoreButton';
import TV from '../../../../static/images/Tv_mpbile.png';
import TVwebp from '../../../../static/images/Tv_mpbile.webp';
import CallToActionBlock from '../../sections/CallToActionBlock';
import TextBlock from '../TextBlock/index.js';

const itemsCallToActionText = [
    'Выберите услугу и оставьте заявку на сайте.',
    'С вами свяжется менеджер и поможет подобрать тариф.',
    'В удобное вам время техник оформит договор, проведет кабель и настроит оборудование.'
];

const Container = styled.div`
    width: 100%;
    ${FONTS.S};
    @media (max-width: 1023px) {
        margin-top: 30px;
    }
`;

const Bonus = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-bottom: 50px;
    border-bottom: 1px solid ${COLORS.grey};
    @media(min-width: 1180px) {
        flex-direction: ${p => p.isScrolled ? 'row-reverse' : 'row'};
        justify-content: space-between;
    }
`;

const Promo = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    flex-wrap: wrap;
    width: 100%;
`;

const WrapperText = styled.div`
    display: flex;
    flex-direction: column;
    @media(min-width: 1180px) {
        width: 550px;
    }
`;

const WrapperIcon = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    @media(min-width: 1180px) {
        flex-direction: row;
        justify-content: flex-start;
        margin-top: 25px;
    }
`;

const WrapperMobileBtn = styled.div`
    display: flex;
    justify-content: space-between;
    width: 305px;
`;

const Picture = styled.picture`
    margin-top: 35px;
    align-self: center;
    @media(max-width: 390px) {
        width: 100%
    }
`;

const Img = styled.img`
    max-width: 350px;
    @media(max-width: 390px) {
        width: calc(100% - 20px);
    }
`;

const Source = styled.source`
    max-width: 350px;
    @media(max-width: 390px) {
        width: calc(100% - 20px);
    }
`;

const IconImg = styled.img`
    max-width: 100%;
    max-height: 100%;
`;

const Title = styled.h2`
    margin-top: 0;
    margin-top: 50px;
    margin-bottom: 25px;
    ${FONTS.XXL};
    
    color: #000000;
`;

const Text = styled.p`
    margin: 0;
    margin-bottom: 20px;
    ${FONTS.S};
    color: #979797;
`;

const BonusContent = styled.div`
    margin-bottom: 0;
    width: calc(100% - 60px);
    padding: 0 20px;
`;

const BonusTitle = styled(Text)`
    color: #000;
    margin-bottom: 10px;
`;

const BonusText = styled(Text)`
    color: #000;
    margin-bottom: 0;
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  margin-bottom: 20px;
  background: #fff;
  border-radius: 50%;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

const PromoText = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    margin-bottom: 20px;
    @media(min-width: 1180px) {
        width: 330px;
        margin-bottom: 50px;
    }
`;

const Extra = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    width: 100%;
`;

const ExtraBody = styled.div`
    background-color: #fff;
    border-bottom: 1px solid ${COLORS.grey};
    color: #000000;
    padding: 20px 18px;

    @media(min-width: 768px) {
        padding-bottom: 25px;
        padding-top: 25px;
    }
`;

const ExtraFooter = styled.div`
    background-color: #fff;
    color: #979797;
    display: inline-block;
    ${FONTS.XS};
    padding: 14px 42px 18px;
    vertical-align: middle;

    @media(min-width: 768px) {
        padding-top: 20px;
        padding-bottom: 30px;
    }

    @media(min-width: 1180px) {
        padding-top: 25px;
        padding-bottom: 25px;
    }
`;

const ExtraContentTitle = styled.h3`
    margin-bottom: 15px;
    @media(min-width: 768px) {
        ${FONTS.H4};
    }
`;

const ExtraContentDesc = styled.span`
    color: #000;
    margin: 10px 0 20px;
`;

const ExtraContentText = styled.p`
    color: #000;
    margin: 20px 0 10px;
`;

const ExtraContentList = styled.ol`
    counter-reset: list;
`;

const ExtraContentListItem = styled.li`
    counter-increment: list;
    margin-bottom: 14px;
    padding-left: 25px;
    position: relative;

    @media(min-width: 768px) {
        margin-bottom: 20px;
    }

    &:last-child {
        margin-bottom: 0;
    }

    &::before {
        content: counter(list) ". ";
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
    }
`;

const TextBlockSection = styled.div`
    display: block;
    margin: 0 0 30px;
`;

class BundlesContent extends React.PureComponent {

    state = {
        isScrolled: false
    };

    render() {

        const { pageContent, isVillage, city } = this.props;
        const { isScrolled } = this.state;

        return (
            <Fragment>
                <Container>
                    <Bonus isScrolled={isScrolled} itemScope itemType='http://schema.org/ImageObject'>
                        {
                            isScrolled &&
                            <Picture>
                                <Source srcSet={TVwebp} type='image/webp' />
                                <Img src={TV} alt='Амедиатека в пакете интернет и ТВ' title='Амедиатека в пакете интернет и ТВ' itemProp='contentUrl'/>
                            </Picture>
                        }
                        <WrapperText>
                            <Title itemProp='name'>Мобильное ТВ бесплатно на всех тарифах при подключении</Title>
                            <Text itemProp='description'>Не скучайте в пробках и очередях. Смотрите телевизор на смартфоне, планшете или ноутбуке. Установите приложение Movix или зайдите на сайт онлайн-кинотеатра.</Text>
                            <WrapperMobileBtn>
                                <MobileStoreButton rel='nofollow noopener noreferrer' store='MovixAppStore' target='_blank' color='#fff' />
                                <MobileStoreButton rel='nofollow noopener noreferrer' store='MovixGooglePlay' target='_blank' color='#fff' />
                            </WrapperMobileBtn>
                        </WrapperText>
                    </Bonus>
                    <Promo>
                        <Title >{pageContent.titleClients}</Title>
                        <WrapperIcon>
                            {
                                pageContent.clients.map((element, index) => (
                                    <PromoText key={index} itemScope itemType='http://schema.org/ImageObject'>
                                        <Icon>
                                            <IconImg src={`../../../../static/images/icons/${element.images}`} alt='' itemProp='contentUrl' />
                                        </Icon>
                                        <BonusContent>
                                            <BonusTitle itemProp='name'>{element.title}</BonusTitle>
                                            <BonusText itemProp='description'>{element.text}</BonusText>
                                        </BonusContent>
                                    </PromoText>
                                ))
                            }
                        </WrapperIcon>
                        <CallToActionBlock
                            title={<Fragment>Подключить <span>ТВ + Интернет</span></Fragment>}
                            itemsCallToActionText={itemsCallToActionText}
                        />
                    </Promo>
                    {isVillage
                        ? <TextBlockSection>
                            <TextBlock />
                        </TextBlockSection>
                        : null
                    }
                    <Extra>
                        <ExtraBody>
                            <ExtraContentTitle>{pageContent.titleCeoBlock}</ExtraContentTitle>
                            <ExtraContentDesc>{pageContent.descriptionCeoBlock}</ExtraContentDesc>
                            <ExtraContentDesc>{pageContent.descriptionCeoBlock2}</ExtraContentDesc>
                            <ExtraContentList>
                                {
                                    pageContent.listCeoBlock.map((element, index) => (
                                        <ExtraContentListItem key={index} dangerouslySetInnerHTML={{ __html: element }}/>
                                    ))
                                }
                            </ExtraContentList>
                            <ExtraContentText>
                                После чего вы можете сразу же пользоваться новыми услугами.
                            </ExtraContentText>
                        </ExtraBody>
                        {isVillage
                            ? <ExtraFooter dangerouslySetInnerHTML={{ __html: pageContent.footerCeoBlock }}/>
                            : <ExtraFooter dangerouslySetInnerHTML={{ __html: pageContent.footerCeoBlock + city }}/>
                        }
                    </Extra>
                </Container>
            </Fragment>
        );
    }

    componentDidMount() {
        if (document.documentElement.scrollTop > 0) {
            this.setState({ isScrolled: true });
        }

        if (process.browser) {
            window.addEventListener('scroll', this.loadImage);
        }
    }

    loadImage = () => {
        this.setState({ isScrolled: true });
        window.removeEventListener('scroll', this.loadImage);
    };

    componentWillUnmount() {
        if (process.browser) {
            window.removeEventListener('scroll', this.loadImage);
        }
    }
}

export default BundlesContent;
